"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashNotification = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("@smartsuite/types");
const classnames_1 = __importDefault(require("classnames"));
const Icon_1 = require("@smartsuite/react-ui/lib/components/utils/Icon/Icon");
const Paragraph_1 = require("@smartsuite/react-ui/lib/components/typography/Paragraph/Paragraph");
const flash_notifications_constants_1 = require("../../flash-notifications.constants");
const FlashNotification = ({ children, level, }) => {
    let iconName;
    let iconColor;
    switch (level) {
        case flash_notifications_constants_1.FlashNotificationLevel.warning:
            iconName = "warning";
            iconColor = "currentColor";
            break;
        case flash_notifications_constants_1.FlashNotificationLevel.success:
            iconName = "checkmark";
            iconColor = "reverse";
            break;
        case flash_notifications_constants_1.FlashNotificationLevel.start:
            iconName = "rocket";
            iconColor = types_1.Colors.bYellow;
            break;
    }
    const iconClasses = (0, classnames_1.default)("flash-notification__icon", `flash-notification__icon--${level}`);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flash-notification", children: [(0, jsx_runtime_1.jsx)("div", { className: iconClasses, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: "M", name: iconName, color: iconColor }) }), (0, jsx_runtime_1.jsx)(Paragraph_1.Paragraph, { color: "currentColor", children: children })] }));
};
exports.FlashNotification = FlashNotification;
